import { render, staticRenderFns } from "./SupplierHome.vue?vue&type=template&id=8733b2f8&scoped=true"
import script from "./SupplierHome.vue?vue&type=script&lang=js"
export * from "./SupplierHome.vue?vue&type=script&lang=js"
import style0 from "./SupplierHome.vue?vue&type=style&index=0&id=8733b2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8733b2f8",
  null
  
)

export default component.exports